import {createRoot} from 'react-dom/client';

// eslint-disable-next-line import-js/order
import extendNumber from 'web-app/setup/prototype-extensions/number';

extendNumber();

import 'web-app/setup/prototype-extensions/load-prototype-extensions';
import 'rxjs';
import 'core-js/actual/object/has-own'; // react-markdown requires this – at least while we have to support iOS versions <15.4
import 'core-js/actual/structured-clone'; // Safari 15.3 and below does not support structuredClone, and it is used by @pdfme/ui
import {setupResizeObserverBorderBoxSize} from 'web-app/setup/resize-observer-border-box-size-setup';
import setupSentry from 'web-app/shared/sentry-setup';
import {setupMoment} from 'web-app/setup/moment-setup';
import setupNumeral from 'web-app/setup/numeral-setup';
import ENV from 'web-app/config/environment';
import {withTranslationsReady$} from 'web-app/react/routes/application-route-helpers/with-translations';
import {recordBootStage} from 'web-app/react/routes/application-route-helpers/record-boot-stage';
import {installFindDOMNodeShim} from '@famly/vet_ts-utils_react-dom-shim';
import {registerMaterialSymbolsSubset} from '@famly/mf_data-display_icon';
import {shouldReloadAfterAppChunkLoadError} from 'web-app/setup/should-reload-after-app-chunk-load-error';

// React 19 removed ReactDOM.findDOMNode, which some legacy dependencies (react-transition-group)
// still call internally. Re-expose it before anything renders.
installFindDOMNodeShim();

// react-window@2 reads `ResizeObserverEntry.borderBoxSize[0]`, which is undefined on Safari/iOS < 15.4 (APP-PRODUCTION-5SE)
setupResizeObserverBorderBoxSize();

// Only this rspack entry loads the subset. The webpack build, which most production environments
// still serve and no CI job tests, keeps every icon on the full font until it is retired.
const materialSymbolsSubsetFontUrl = process.env.MATERIAL_SYMBOLS_SUBSET_FONT_URL;
if (materialSymbolsSubsetFontUrl) {
    registerMaterialSymbolsSubset(materialSymbolsSubsetFontUrl);
}

// The Sentry SDK should be initialized as early as possible on app startup.
setupMoment();
setupNumeral();
setupSentry(ENV as any);
recordBootStage('entry-started');

withTranslationsReady$.subscribe(() => {
    recordBootStage('translations-ready');
    import('./app/app')
        .then(App => {
            recordBootStage('react-app-loaded');
            const root = createRoot(document.getElementById('root')!);
            root.render(<App.default />);
        })
        .catch(error => {
            if (shouldReloadAfterAppChunkLoadError(error)) {
                window.location.reload();
            }
        });
});
